'use es6';

import { BUTTON_DISABLED_TEXT } from 'HubStyleTokens/colors';
import styled from 'styled-components';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UIIcon from 'UIComponents/icon/UIIcon';
import UITooltip from 'UIComponents/tooltip/UITooltip';
import { jsx as _jsx } from "react/jsx-runtime";
const Icon = styled(UIIcon).withConfig({
  displayName: "RestrictedPropertyIcon__Icon",
  componentId: "j1oj48-0"
})(["padding:0 1px;margin-left:7px;"]);
const RestrictedPropertyIcon = () => {
  return /*#__PURE__*/_jsx(UITooltip, {
    placement: "top",
    title: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "customerDataFilters.FilterEditor.restrictedPropertyTooltip"
    }),
    children: /*#__PURE__*/_jsx(Icon, {
      color: BUTTON_DISABLED_TEXT,
      name: "hide"
    })
  });
};
export default RestrictedPropertyIcon;